import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import type { KnowledgeInboxEntry } from "../../../api/content/reviewCollaborationApi";
import { formatTimeAgo } from "../../../shared/formatting/relativeTimes";
import { parseDocumentVersionRef } from "../../../shared/references/contentReferences";
import { useDocumentLabel } from "../../sources";
import { proposalPath } from "../../knowledgeData/extractions/proposalPath";
import OpenReview from "../../knowledgeData/results/OpenReview";
import { namedPerson } from "../../threads/data/namedPerson";
import { useMemberNames } from "../../threads/data/useMemberNames";

export default function KnowledgeDataSection({ projectId, entries }: { projectId: string; entries: readonly KnowledgeInboxEntry[] }) {
  const { t, i18n } = useTranslation();
  const people = useMemberNames(projectId);
  if (entries.length === 0) return null;
  return <div className="px-3 py-2">
    <h4 className="app-title text-sm font-semibold">{t("data.lineage.inbox")}</h4>
    <ul>{entries.map((entry) => <li key={entry.source}>
      <Link className="app-link text-sm" to={proposalPath(entry.source)}><DocumentName reference={entry.document} /></Link>{" "}
      <OpenReview source={entry.source} state="proposed" review={null} />
      <p className="app-text-muted text-xs">{t("data.lineage.inboxEntry", { ...namedPerson(people, entry.by), time: formatTimeAgo(entry.recordedAt, i18n.resolvedLanguage), statements: t("data.counts.statements", { count: entry.statements }), newer: t("data.counts.newerProposals", { count: entry.newerPendingCount }) })}</p>
    </li>)}</ul>
  </div>;
}

/** The result's document as the app names a document; "Document" until its name is read. */
function DocumentName({ reference }: { reference: string }) {
  return <>{useDocumentLabel(parseDocumentVersionRef(reference))}</>;
}
